import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import AxisSpinner from "./AxisSpinner";
import { saveAs } from "file-saver";
import { ButtonModalOnClickClose } from "./ButtonModalSelection";

const TimesheetPdfEditor = ({ shift, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    fetchTimesheet();
  }, [shift]);

  const download = async () => {
    saveAs(pdfUrl, shift?.timesheet?.filename);
  };

  const fetchTimesheet = async () => {
    try {
      setLoading(true);

      var params = {
        timesheet_id: shift?.timesheet?.id,
      };

      const config = {
        responseType: "arraybuffer",
        params: params,
      };

      const response = await authAxios().get(
        "/api/backoffice/timesheet/timesheet_file",
        config,
      );

      var blob = new Blob([response.data], { type: "application/pdf" });
      var pdfUrl = window.URL.createObjectURL(blob);
      setPdfUrl(pdfUrl);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  return (
    <Fragment>
      {loading ? (
        <AxisSpinner loading={loading} />
      ) : (
        <div height="100%" width="100%">
          <iframe
            height="800"
            width="100%"
            title={shift?.timesheet?.filename}
            src={pdfUrl}
            type="application/pdf"
          />
        </div>
      )}
      <ButtonModalOnClickClose
        onClickFunc={download}
        close={close}
        loading={loading}
        funcButtonName={"Download"}
      />
    </Fragment>
  );
};

export default TimesheetPdfEditor;
